import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, HStack, Button, useStyleConfig} from '@chakra-ui/react'
import {TextTitleDescription} from '../../text-title-description'
import {ChevronRight} from '../../../icons/arrows'
import {remCalc} from '../../../../theme/_utils'
import CustomLink from '../../../custom-link'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import useDamImage from '../../../../custom-hooks/use-dam-image'

const PromoSlideImageCard = ({title, bodyCopy, button, url, alt, images}) => {
    const styles = useStyleConfig('PromoSlider')
    const categoryData = useGetCategoriesData()
    const {url: ctaUrl, label: ctaLabel, isAbsolute} = getGlobalLink(button, categoryData)

    const {url: imageUrl, ratio} = useDamImage(images)
    // const handleRedirect = (e) => {
    //     e.preventDefault()
    //     if (cta && cta?.href) {
    //         isExternalUrl ? window.open(cta.href, '_blank') : navigate(cta.href)
    //     }
    // }

    const imageToDisplay = imageUrl || url

    return (
        <CustomLink isExternal={isAbsolute} href={ctaUrl} data-testid="promo-slide-image-card-link">
            <Box
                {...styles.promoSlideImageContainer}
                data-testid={`swiper-slide-image-${title || 'container'}`}
            >
                <Flex
                    __css={styles.promoSlideBackground}
                    backgroundImage={imageToDisplay ? `url(${imageToDisplay})` : 'none'}
                    aria-label={alt || 'background image description'}
                    aspectRatio={{lg: ratio}}
                >
                    <Flex sx={styles.promoSliderContent}>
                        <TextTitleDescription
                            title={title}
                            color="text.inverse"
                            textStyle="head-large"
                            weight="500"
                            titleSpacing={{base: remCalc(16), md: remCalc(24)}}
                            childrenTextColor="text.inverse"
                            childrenTextStyle="body-large"
                            mb={{base: remCalc(16), md: remCalc(24)}}
                        >
                            {bodyCopy}
                        </TextTitleDescription>
                        {ctaLabel && (
                            <Button variant="inverse" aria-label={ctaLabel} tabIndex={0}>
                                <HStack gap={remCalc(10)}>
                                    <Text as="span" color="text.inverse" fontStyle="body-medium">
                                        {ctaLabel}
                                    </Text>
                                    <ChevronRight
                                        aria-label="right icon"
                                        backgroundColor="background.default"
                                        borderRadius="50%"
                                    />
                                </HStack>
                            </Button>
                        )}
                    </Flex>
                </Flex>
            </Box>
        </CustomLink>
    )
}

PromoSlideImageCard.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    button: PropTypes.object,
    url: PropTypes.string,
    alt: PropTypes.string,
    images: PropTypes.object,
    isExternalUrl: PropTypes.bool,
}

export default PromoSlideImageCard
